import { render, staticRenderFns } from "./DoubleSquareCard.vue?vue&type=template&id=d7c2c9c0&"
import script from "./DoubleSquareCard.vue?vue&type=script&lang=js&"
export * from "./DoubleSquareCard.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSquareCard.vue?vue&type=style&index=0&id=d7c2c9c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FullImgCard: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/FullImgCard.vue').default})
